import axios from "axios"

interface Response {
  user: {
    id: string
    username: string
    first_name: string
    last_name: string
    phone_number: string
    phone_country_code: string
    admin: string
    discord_member_id: string
    verified: string
    created_at: string
    updated_at: string
    profilePicUrl: string
    timezone_utc_offset: number | null
  }
  token: string
}

export const login = async (username: string, password: string) => {
  try {
    const res = await axios.post<Response>(`/login`, { username, password })
    return res.data
  } catch (err) {
    console.log("login err", err)
  }
  return null
}
